/* The Whole Story – collection page: row tabs (with the moving scribble) + product navigation.
   Used by sections/twst-collection-showcase.liquid. */
(() => {
  if (window.twstCollection) return;
  window.twstCollection = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 989px)');

  /* ---------- Tabs ---------- */
  // Scribble = Figma "Vector 10": ~18px wider and ~1.8× taller than the active label, centred on it.
  // Measured from the label text, not the button – the button is taller than the text (44px tap target).
  const place = (tabs) => {
    const on = tabs.querySelector('[aria-pressed="true"]');
    const mark = tabs.querySelector('.twst-card__scribble');
    if (!on || !mark) return;
    const range = document.createRange();
    range.selectNodeContents(on);
    const text = range.getBoundingClientRect();
    const box = tabs.getBoundingClientRect();
    if (!text.width) return;
    const w = text.width + 18;
    // 1.91 × text height = the old 1.8 × label-box height (the text box is a little shorter than the old button)
    const h = text.height * 1.91;
    mark.style.left = `${text.left - box.left + text.width / 2 - w / 2}px`;
    mark.style.top = `${text.top - box.top + text.height / 2 - h / 2}px`;
    mark.style.width = `${w}px`;
    mark.style.height = `${h}px`;
  };

  const resizer = 'ResizeObserver' in window ? new ResizeObserver((entries) => entries.forEach((e) => place(e.target))) : null;

  const initTabs = (root) => {
    root.querySelectorAll('[data-twst-tabs]').forEach((tabs) => {
      place(tabs);
      tabs.classList.add('is-ready');
      requestAnimationFrame(() => tabs.classList.add('is-anim'));
      if (resizer) resizer.observe(tabs);
    });
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-twst-tab]');
    if (!btn) return;
    const tabs = btn.closest('[data-twst-tabs]');
    const stage = btn.closest('[data-twst-row]').querySelector('.twst-card__stage');
    tabs.querySelectorAll('[data-twst-tab]').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
    stage.dataset.tab = btn.dataset.twstTab;
    place(tabs);
  });

  /* ---------- Product navigation ---------- */
  const initNav = (root) => {
    const nav = root.querySelector('[data-twst-cnav]');
    if (!nav) return;
    const list = nav.querySelector('.twst-cnav__list');
    const links = [...nav.querySelectorAll('.twst-cnav__link')];
    const rows = links.map((l) => document.getElementById(l.dataset.target)).filter(Boolean);

    // rows scroll below the mobile bar
    const setOffset = () => root.style.setProperty('--twst-cnav-h', mobile.matches ? `${nav.offsetHeight}px` : '0px');
    setOffset();
    mobile.addEventListener('change', setOffset);
    window.addEventListener('resize', setOffset, { passive: true });

    const activate = (id) => {
      links.forEach((l) => {
        const on = l.dataset.target === id;
        l.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && mobile.matches && list.scrollWidth > list.clientWidth) {
          const li = l.parentElement;
          list.scrollTo({
            left: li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2,
            behavior: reduce.matches ? 'auto' : 'smooth',
          });
        }
      });
    };

    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && activate(e.target.id)),
      { rootMargin: '-45% 0px -50% 0px' }
    );
    rows.forEach((r) => io.observe(r));

    nav.addEventListener('click', (event) => {
      const link = event.target.closest('.twst-cnav__link');
      const row = link && document.getElementById(link.dataset.target);
      if (!row) return;
      event.preventDefault();
      row.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      activate(row.id);
    });
  };

  const init = (root) => {
    initTabs(root);
    initNav(root);
  };

  const boot = () => {
    document.querySelectorAll('[data-twst-showcase]').forEach(init);
    // labels change width once the display font arrives
    if (document.fonts) document.fonts.ready.then(() => document.querySelectorAll('[data-twst-tabs]').forEach(place));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-twst-showcase]');
    if (root) init(root);
  });
})();
